import React from 'react';
import { Briefcase, Cpu, Scale, Megaphone, ChartNoAxesCombined, Building2, Brain, Palette, GraduationCap, HeartPulse } from 'lucide-react';

const icons: Record<string, typeof Briefcase> = { ingenieria: Building2, arquitectura: Building2, tecnologia: Cpu, legal: Scale, derecho: Scale, marketing: Megaphone, finanzas: ChartNoAxesCombined, contabilidad: ChartNoAxesCombined, psicologia: Brain, salud: HeartPulse, diseno: Palette, educacion: GraduationCap };
export default function ProfessionalIcon({ category, size = 20 }: { category: string; size?: number }) {
    const Icon = icons[category] || Briefcase;
    return <Icon size={size} strokeWidth={1.8} aria-hidden="true" style={{display:'inline-block',verticalAlign:'middle'}}/>;
}
